<template>
  <b-form-group
    label="Ölçüler"
    label-for="title"
  >
    <validation-provider
      #default="{ errors }"
      name="Ölçüler"
      rules="required"
    >
      <b-form-input
        id="sizes"
        v-model="dataItem[iKey].sizes"
        placeholder="Ölçüler"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'ProductItemsSizes',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  props: {
    iKey: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['productItems/dataList']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
